import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import {FilterMenu} from "../../filterMenu";
import {pageSizes} from "../../table/tablePagination";

const TablePagination = ({handlePreviousPage, handleNextPage, pagination, showOnPage}) => {
    const { t } = useTranslation('Common');

    return (
        <div
            className={`fk-pagination${
                !pagination.hasPrevious ? " --flex-end" : ""
            }`}
        >
            {pagination.hasPrevious && (
                <Button
                    className="fk-button fk-button--outline"
                    onClick={handlePreviousPage}
                >
                    {t('previous')}
                </Button>
            )}
            {showOnPage &&
                <div style={{paddingRight: 36, justifyContent: 'center', alignItems: 'center', display: 'flex'}}>
                    <FilterMenu
                        disableClear
                        label={"Show"}
                        options={pageSizes}
                        selected={pageSizes.find(i => i.value === pagination.pageSize)}
                        onChange={(option) => showOnPage(option.value)}
                    />
                </div>
            }
            {pagination.hasNext && (
                <Button
                    className="fk-button fk-button--primary"
                    onClick={handleNextPage}
                >
                    {t('next')}
                </Button>
            )}
        </div>
    );
};

export default TablePagination;